import React from 'react'
import FormulaButton from '../formulaButton'
import AtomicMassForm from '../../container/atomicMassForm'

export default class MolarMassButton extends React.Component {
    render() {
        return (
            <div>
                <FormulaButton label="Molar Mass" iconName="atomicMass">
                    <AtomicMassForm/>
                </FormulaButton>
            </div>
        )
    }
}